module.exports = __webpack_public_path__ + "static/media/3_k1U_1,35_45,19.3fb3e88b.png";